import { forwardRef } from 'react';
import { clsx } from 'clsx';

const Input = forwardRef(({ 
  label,
  error,
  icon,
  rightIcon,
  className = '', 
  ...props 
}, ref) => {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          {label}
        </label>
      )}
      <div className="relative">
        {icon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <div className="text-gray-400">
              {icon}
            </div>
          </div>
        )}
        <input
          ref={ref}
          className={clsx(
            'input-field',
            icon && 'pl-10',
            rightIcon && 'pr-10',
            error && 'border-semantic-neg focus:ring-semantic-neg',
            className
          )}
          style={icon ? { paddingLeft: '2.5rem' } : undefined}
          {...props}
        />
        {rightIcon && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
            {rightIcon}
          </div>
        )}
      </div>
      {error && (
        <p className="mt-1 text-sm text-semantic-neg">{error}</p>
      )}
    </div>
  );
});

Input.displayName = 'Input';

export default Input;
